const ALLOWED_TAGS = new Set([
  'a', 'abbr', 'b', 'blockquote', 'br', 'code', 'div', 'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
  'hr', 'i', 'li', 'ol', 'p', 'pre', 'span', 'strong', 'u', 'ul', 'table', 'thead', 'tbody', 'tr',
  'th', 'td'
]);

const GLOBAL_ALLOWED_ATTRS = new Set(['class', 'title', 'aria-label']);
const TAG_ALLOWED_ATTRS = {
  a: new Set(['href', 'target', 'rel', 'title']),
  th: new Set(['colspan', 'rowspan']),
  td: new Set(['colspan', 'rowspan'])
};

const isSafeUrl = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return false;
  if (raw.startsWith('#') || raw.startsWith('/')) return true;

  try {
    const parsed = new URL(raw, window.location.origin);
    return ['http:', 'https:', 'mailto:', 'tel:'].includes(parsed.protocol);
  } catch (_e) {
    return false;
  }
};

export const sanitizeHtml = (input) => {
  const html = String(input || '');
  if (!html) return '';
  if (typeof window === 'undefined' || typeof window.DOMParser === 'undefined') return html;

  const parser = new window.DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const elements = Array.from(doc.body.querySelectorAll('*'));

  for (const element of elements) {
    const tagName = element.tagName.toLowerCase();

    if (!ALLOWED_TAGS.has(tagName)) {
      const fragment = doc.createDocumentFragment();
      while (element.firstChild) {
        fragment.appendChild(element.firstChild);
      }
      element.replaceWith(fragment);
      continue;
    }

    const tagAllowed = TAG_ALLOWED_ATTRS[tagName] || new Set();
    for (const attr of Array.from(element.attributes)) {
      const name = attr.name.toLowerCase();
      const value = String(attr.value || '');

      const allowed = GLOBAL_ALLOWED_ATTRS.has(name) || tagAllowed.has(name);
      const isEventHandler = name.startsWith('on');
      const isStyleLike = name === 'style' || name === 'srcdoc';

      if (!allowed || isEventHandler || isStyleLike) {
        element.removeAttribute(attr.name);
        continue;
      }

      if ((name === 'href' || name === 'src') && !isSafeUrl(value)) {
        element.removeAttribute(attr.name);
      }
    }

    if (tagName === 'a') {
      if (element.getAttribute('target') === '_blank') {
        element.setAttribute('rel', 'noopener noreferrer');
      }
    }
  }

  return doc.body.innerHTML;
};
